export const CONSENT_STORAGE_KEY = "ss_cookie_consent";

export const DEFAULT_CONSENT = {
  necessary: true,
  analytics: false,
  marketing: false,
  updatedAt: null,
};

export const getStoredConsent = () => {
  if (typeof window === "undefined") return null;

  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.analytics !== "boolean") return null;
    if (typeof parsed?.marketing !== "boolean") return null;
    return {
      necessary: true,
      analytics: parsed.analytics,
      marketing: parsed.marketing,
      updatedAt: parsed.updatedAt ?? null,
    };
  } catch {
    return null;
  }
};

export const saveConsent = (consent) => {
  if (typeof window === "undefined") return consent;

  const next = {
    necessary: true,
    analytics: Boolean(consent.analytics),
    marketing: Boolean(consent.marketing),
    updatedAt: new Date().toISOString(),
  };

  window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(next));
  return next;
};

export const acceptAllConsent = () =>
  saveConsent({ analytics: true, marketing: true });

export const rejectNonEssentialConsent = () =>
  saveConsent({ analytics: false, marketing: false });
